import api from './client';

export const listOwnShareGrants = async () => {
  const { data } = await api.get('/sharing/grants');
  return data;
};

export const listReceivedShareGrants = async () => {
  const { data } = await api.get('/sharing/received');
  return data;
};

export const getShareGrant = async (grantId) => {
  const { data } = await api.get(`/sharing/grants/${grantId}`);
  return data;
};

export const createShareGrant = async (payload) => {
  const { data } = await api.post('/sharing/grants', payload);
  return data;
};

export const revokeShareGrant = async (grantId) => {
  const { data } = await api.post(`/sharing/grants/${grantId}/revoke`);
  return data;
};

export const getShareGrantHistory = async (grantId) => {
  const { data } = await api.get(`/sharing/grants/${grantId}/history`);
  return data;
};
